import React from 'react';

import { StyleSheet } from 'react-native';

import Picture from 'components/picture';
import { Box, BoxProps, withTypography } from 'components/ui';
import { primitive, spacing } from 'styles/constants';

export const CallToActionHeaderContainer = Box;

export const CallToActionHeading = withTypography({
  variant: 'headerTwo',
  textAlign: 'center',
  mt: '$4',
});

export const CallToActionSubheading = withTypography({
  variant: 'headerThree',
  textAlign: 'center',
  color: primitive.$fieryRed,
  style: { fontWeight: '400' },
});

export const CallToActionBody = withTypography({ mb: '$8' });

export const Image = Picture.withConfig({
  width: '66%',
  objectFitContain: true,
  marginX: 'auto',
});

export const CallsToAction = ({ children, style, ...props }: BoxProps) =>
  React.createElement(Box, { ...props, style: [styles.callsToAction, style] }, children);

export const CallToAction = ({ children, style, ...props }: BoxProps) =>
  React.createElement(Box, { ...props, style: [styles.callToAction, style] }, children);

const styles = StyleSheet.create({
  callsToAction: {
    gap: spacing.$16,
    marginBottom: spacing.$16,
    marginHorizontal: 'auto',
    marginTop: 0,
    maxWidth: 920,
    width: '90%',
  },
  callToAction: {
    width: '100%',
  },
});
